import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useExternalContentHttp } from '@/core/api/external-contents'
import { ExternalContent, ExternalContentPayload } from '@/core/models/external-content'

export type ExternalContentCollection = {
    data: Array<ExternalContent>,
    meta?: MetaPayload,
    links?: any
}

const state: ExternalContentCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const externalContentCollection: Module<ExternalContentCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ExternalContentCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ExternalContentPayload) => {
                state.data.push(new ExternalContent(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useExternalContentHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ExternalContentCollection): ExternalContentCollection => {
            return state
        }
    }
}
